import { render, staticRenderFns } from "./LmCustomerNewOrEdit.vue?vue&type=template&id=65052014"
import script from "./LmCustomerNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmCustomerNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports